import React, { Component } from 'react';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayFor: props.AgencyLogoServerPath != "" ? "block" : "none",
            agencyLogo: props.AgencyLogoServerPath != "" ? props.AgencyLogoServerPath : "./images/logo3.png",
            domainName: props.config.DomainName != "" ? props.config.DomainName : "Producer MAX",
            domainURL: props.config.DomainURL != "" ? props.config.DomainURL : "https://producermax.com/",
            displayPMaXL: props.AgencyLogoServerPath != "" ? "block" : "none",
            displayPMaXL1: props.AgencyLogoServerPath != "" ? "none" : "block"
        };
        window.document.title = props.config.WebCRMLabelName != "" ? props.config.DomainName + " - " + props.config.WebCRMLabelName : "ProducerMAX - Web SOA";
    }

    render() {
        return (
            <div>
                <header>
                    <div className="container" style={{ display: this.state.displayPMaXL }}>
                        <div className="row" >
                            <div className="col pm_logo_L_col">
                                <div className="pm_logo_L">
                                    <a href={this.state.domainURL} target="_blank"><img src='./images/logo.png' alt={this.state.domainName} title={this.state.domainName} /></a>
                                </div>
                            </div>
                            <div className="col" style={{ display: this.state.displayFor }}>
                                <div className="row">
                                    <div className="col pm_logo_R" style={{ display: this.state.displayFor }}>
                                        <div className="l_for" style={{ display: this.state.displayFor }}>
                                            <span className="pm_logo_R for">For&nbsp;&nbsp;</span>
                                        </div>
                                        <div className="r_for_img">
                                            <a><img src={this.state.agencyLogo}
                                                alt={this.state.domainName} /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container" style={{ display: this.state.displayPMaXL1 }}>
                        <div className="row" >
                            <div className="col pm_logo_L_col1">
                                <div className="pm_logo_L">
                                    <a href={this.state.domainURL} target="_blank"><img src='./images/logo.png' alt={this.state.domainName} title={this.state.domainName} /></a>
                                </div>
                            </div>
                            <div className="col" style={{ display: this.state.displayFor }}>
                                <div className="row">
                                    <div className="col pm_logo_R" style={{ display: this.state.displayFor }}>
                                        <div className="l_for" style={{ display: this.state.displayFor }}>
                                            <span className="pm_logo_R for">For</span>
                                        </div>
                                        <div className="r_for_img">
                                            <a><img src={this.state.agencyLogo}
                                                alt={this.state.domainName} /></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
        );
    }
}

export default Header;